import React, { useEffect, useState } from "react";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import {
	updateAbout,
	updateContact,
	updateCookiePolicy,
	updatePrivacyPolicy,
	updateTerm,
	updateTermOfUse,
} from "../../../../services/UserService";

export default function useUpdateContent(props: { dialogType: string; setOpenDialog: (value: boolean) => void }) {
	const { openAlertDialog } = useAlertDialog();

	const updateContent = async (dialogType: string, content: string): Promise<string> => {
		switch (dialogType) {
			case "terms_of_use":
				return await updateTermOfUse(content);
			case "terms_conditions":
				return await updateTerm(content);
			case "privacy_policy":
				return await updatePrivacyPolicy(content);
			case "cookie_policy":
				return await updateCookiePolicy(content);
            case "about_us":
                return await updateAbout(content);
            case "contact_us":
                return await updateContact(content);
			default:
				return "Không tìm thấy nội dung phù hợp.";
		}
	};

	const doUpdate = async (content: string) => {
		try {
			await updateContent(props.dialogType, content);
			openAlertDialog?.(AlertType.Success, "Thay đổi thành công!", () => {});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "An error has occurred!", () => {});
		}
	};

	return {
		doUpdate,
	};
}
